import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const msg: string = 'Please, select Records per Page'
const schema = yup.object({
  pageSize: yup.object().nullable().required(msg),
})

const resSettings = yupResolver(schema)

export default resSettings
